<template>
  <!-- Breadcrumb -->
  <v-row>
    <v-col cols="12">
      <v-breadcrumbs
        class="text-caption py-0 px-0"
        :items="viewModel.breadcrumbs"
      >
        <template v-slot:prepend>
          <v-icon icon="mdi-chart-bar" size="small"></v-icon>
        </template>
      </v-breadcrumbs>
    </v-col>
  </v-row>
  <!-- Services Section -->
  <v-row>
    <!-- Existing Service Cards -->
    <v-col
      cols="12"
      sm="6"
      md="4"
      lg="3"
      v-for="service in viewModel.services.value"
      :key="service.title"
    >
      <v-card
        height="100%"
        flat
        border
        class="text-center pa-3 d-flex flex-column justify-between text-center"
        style="border-left: 7px solid rgb(var(--v-theme-primary), 0.4)"
      >
        <v-icon
          color="primary"
          :icon="service.icon"
          size="30"
          class="mb-3 mx-auto"
        ></v-icon>
        <v-card-title class="text-subtitle-1 font-weight-bold">{{
          service.title
        }}</v-card-title>
        <v-card-text class="text-subtitle-2">{{
          service.description
        }}</v-card-text>
        <v-card-actions>
          <v-btn
            variant="tonal"
            width="100%"
            color="primary"
            class="text-none"
            @click="viewModel.handleServiceClick(service)"
          >
            {{ service.label }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
  <AccountsDialog ref="accountsDialogRef" />
  <CreditSimuilatorDialog ref="simulatorDialogRef" />
</template>

<script lang="ts" setup>
import { ref } from "vue";
import AccountsDialog from "@/components/dialogs/AccountsDialog.vue";
import ProductsViewModel from "@/viewmodels/app/ProductsViewModel";
import CreditSimuilatorDialog from "@/components/dialogs/CreditSimuilatorDialog.vue";

const accountsDialogRef = ref(null);
const simulatorDialogRef = ref(null);
const viewModel = new ProductsViewModel(accountsDialogRef, simulatorDialogRef);
</script>
